import React, { Component } from 'react';
import { connect } from 'react-redux';
import Button from 'screens/components/basic/Button';
import LOOKUP from 'constants/lookup';
import CardSimple from 'screens/components/basic/CardSimple';
import TextInput from 'screens/components/basic/TextInput';
import CheckInput from 'screens/components/basic/CheckInput';
import TimePickerInput from 'screens/components/basic/TimePickerInput';
import DatePickerInput from 'screens/components/basic/DatePickerInput';
import DialogInput from 'screens/components/advanced/DialogInput';
import { getEmployeeTimesheetByStatus, saveEmployeeShift, clearEmployeeShift } from 'actions/EntityActions';
import { formInput, clearEmployeeShiftForm } from 'actions/FormActions';
import { selectEmployeeShiftModel } from 'selectors/entitySelector';
import { showSnackbar, showError } from 'actions/CommonActions';
import Grid from 'screens/components/basic/Grid';
import { shiftEditCrumb } from 'utils/breadcrumbInfo';
import DialogHeader from 'screens/components/basic/DialogHeader'
import WithRouter from 'custom/withRouter';
import PageHeader from 'screens/components/basic/PageHeader';
import PageBottomWithButtons from 'screens/components/basic/PageBottomWithButtons';

const componentName = 'shiftEdit';

class ShiftEdit extends Component {
    constructor(props) {
        super(props);
        this.state = {
            dialogShowPhoto: false,
            punchInPhoto: null,
            punchOutPhoto: null
        };
    }

    componentDidMount() {
        const employeeId = this.props.params.id;
        const date = this.props.params.date;
        const status = this.props.params.status;
        this.props.clearForm();
        if (employeeId && date) {
            const model = { employeeId: employeeId, date: date, status: status, compName: componentName };
            this.props.getEmployeeTimesheet(model);
        }
    }

    componentWillUnmount = () => {
        this.props.clearForm();
        this.props.clearEmployeeShift();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.employeeShift !== this.props.employeeShift && this.props.employeeShift !== null) {
            this.props.formInput(this.props.employeeShift.punchOutDate, `${componentName}DateOut`);
            this.props.employeeShift.timesheets.forEach(item => {
                this.props.formInput(item.punchInDateString ? item.punchInDateString : new Date().toDateString(), `${componentName}-ClockIn-${item.id}`);
                this.props.formInput(item.punchOutDateString ? item.punchOutDateString : null, `${componentName}-ClockOut-${item.id}`);
                this.props.formInput(item.paidBreak, `${componentName}-PaidBreak-${item.id}`);
                this.props.formInput(item.notes, `${componentName}-Notes-${item.id}`);
                this.props.formInput(item.approve, `${componentName}-Approve-${item.id}`);
            });
        }

        if (prevProps.saveTimestamp !== this.props.saveTimestamp) {
            if (this.props.saveSuccess === true) {
                this.redirectToList();
                this.props.showSnackbar(LOOKUP.shiftEdit.savedMessage);
            }
            else {
                this.props.showError(this.props.saveError);
            }
        }
    }

    redirectToList = () => {
        this.props.navigate(`/admin/shift/list`);
    }

    getClockInHistory = () => {
        const data = this.props.employeeShift;
        if (!data)
            return [];
        const shifts = data.timesheets.map(item => {
            return {
                Number: item.id,
                ClockIn: <TimePickerInput name={`${componentName}-ClockIn-${item.id}`} hintText="Clock In Time" />,
                ClockOut: <TimePickerInput name={`${componentName}-ClockOut-${item.id}`} hintText="Clock Out Time" />,
                PaidBreak: <CheckInput text="Approve" name={`${componentName}-PaidBreak-${item.id}`} />,
                Icon: <Button
                    type="EditButton"
                    label="Show Photo"
                    primary={true}
                    onTouchTap={() => this.openShowPhotoDialog(item.punchInPhoto, item.punchOutPhoto)} />
            };
        });
        return shifts;
    };

    openShowPhotoDialog = (punchInPhoto, punchOutPhoto) => {
        this.setState({ dialogShowPhoto: true, punchInPhoto, punchOutPhoto });
    }

    closeShowPhotoDialog = () => {
        this.setState({ dialogShowPhoto: false, punchInPhoto: null, punchOutPhoto: null });
    }

    save = () => {
        this.props.save(this.props.model);
    }

    render() {
        return (
            <Grid headerContent={shiftEditCrumb}>
                <PageHeader title={LOOKUP.menu.admin.items.shiftEdit.text} />
                <CardSimple>
                    <div className="row m-0">
                        <div className="col-sm-12">
                            <TextInput
                                name={`${componentName}ID`}
                                type="text"
                                label={LOOKUP.shiftEdit.ID.label}
                                floatingLabelText={LOOKUP.shiftEdit.ID.label}
                                hintText={LOOKUP.shiftEdit.ID.hintText}
                                disabled={true}
                                fullWidth={true} />
                        </div>
                    </div>
                    <div className="row m-0">
                        <div className="col-sm-6">
                            <TextInput
                                name={`${componentName}FirstName`}
                                type="text"
                                label={LOOKUP.shiftEdit.firstName.label}
                                floatingLabelText={LOOKUP.shiftEdit.firstName.label}
                                hintText={LOOKUP.shiftEdit.firstName.hintText}
                                disabled={true}
                                fullWidth={true} />
                        </div>
                        <div className="col-sm-6">
                            <TextInput
                                name={`${componentName}LastName`}
                                type="text"
                                label={LOOKUP.shiftEdit.lastName.label}
                                floatingLabelText={LOOKUP.shiftEdit.lastName.label}
                                hintText={LOOKUP.shiftEdit.lastName.hintText}
                                disabled={true}
                                fullWidth={true} />
                        </div>
                    </div>
                    <div className="row m-0">
                        <div className="col-sm-6">
                            <DatePickerInput
                                name={`${componentName}Date`}
                                floatingLabelText={LOOKUP.shiftEdit.dateIn.label}
                                hintText={LOOKUP.shiftEdit.dateIn.hintText}
                                disabled={true}
                                fullWidth={true} />
                        </div>
                        <div className="col-sm-6">
                            <DatePickerInput
                                name={`${componentName}DateOut`}
                                floatingLabelText={LOOKUP.shiftEdit.dateOut.label}
                                hintText={LOOKUP.shiftEdit.dateOut.hintText}
                                disabled={true}
                                fullWidth={true} />
                        </div>
                    </div>
                </CardSimple>
                <br />
                {
                    this.props.employeeShift ? (
                        this.props.employeeShift.timesheets.map((item, index) => {
                            const modelTimesheet = this.props.model.filter(i => i.id === item.id)[0];
                            return (
                                <div className="pending_box_wrapper" key={index}>
                                    <CardSimple className="paddingForMobileDevicesNoDiv paddingForMobileDevices"
                                        title={(
                                            <div className="pending_box ml-2">
                                                <CheckInput
                                                    className="checkBoxLabels"
                                                    text={`Approve Timesheet #${index + 1}`}
                                                    name={`${componentName}-Approve-${item.id}`}
                                                    checked={item.approve}
                                                />
                                                {modelTimesheet && modelTimesheet.approve ? <span className="label label-success">APPROVED</span> : <span className="label label-warning">PENDING</span>}
                                            </div>
                                        )}
                                    >
                                        <div className="row m-0">
                                            <div className="col-sm-3">
                                                <TimePickerInput
                                                    name={`${componentName}-ClockIn-${item.id}`}
                                                    floatingLabelText="Clock In Time"
                                                    label="Clock In Time"
                                                    hintText="Clock In Time"
                                                    fullWidth={true} />
                                            </div>
                                            <div className="col-sm-3">
                                                <TimePickerInput
                                                    name={`${componentName}-ClockOut-${item.id}`}
                                                    floatingLabelText="Clock Out Time"
                                                    label="Clock Out Time"
                                                    hintText="Clock Out Time"
                                                    fullWidth={true} />
                                            </div>
                                            <div className="col-sm-3">
                                                <br /><br />
                                                <CheckInput className="checkBoxLabels" text="Paid Break?" name={`${componentName}-PaidBreak-${item.id}`} />
                                            </div>
                                            <div className="col-sm-2">
                                                <br />
                                                {
                                                    item.punchInPhoto || item.punchOutPhoto ? (
                                                        <Button
                                                            type="EditButton"
                                                            label="Show Photo"
                                                            className="btnNewBrandPOS"
                                                            primary={true}
                                                            onTouchTap={() => this.openShowPhotoDialog(item.punchInPhoto, item.punchOutPhoto)} />
                                                    ) : null
                                                }
                                            </div>
                                        </div>
                                        <div className="row m-0">
                                            <div className="col-sm-12">
                                                <TextInput
                                                    name={`${componentName}-Notes-${item.id}`}
                                                    type="text"
                                                    label={"Notes"}
                                                    floatingLabelText={"Notes"}
                                                    hintText={"Notes"}
                                                    fullWidth={true} />
                                            </div>
                                        </div>
                                    </CardSimple>
                                    <br />
                                </div>
                            );
                        })
                    ) : null
                }
                <PageBottomWithButtons>
                    <Button
                        name="saveButton"
                        className="pull-right btnNewBrandPOS"
                        label="Verify"
                        onTouchTap={() => this.save()}
                        primary={true} />
                    <Button
                        type="CancelButton"
                        name="buttonCancel"
                        className="pull-right btn-space btnCancelOperation"
                        onTouchTap={() => this.redirectToList()}
                        label="Cancel" />
                </PageBottomWithButtons>
                <DialogInput
                    title={<DialogHeader text="Shift Photo" />}
                    modal={true}
                    open={this.state.dialogShowPhoto}
                    actions={
                        <Button
                            key={1}
                            type="CancelButton"
                            name="buttonCancelRemoveItem"
                            className="btn-space"
                            label="Close"
                            onTouchTap={() => this.closeShowPhotoDialog()} />
                    }
                >
                    <div className="shift_dialog">
                        {
                            this.state.punchInPhoto ? <img src={this.state.punchInPhoto} width="240px" className="img-rounded shift_image" /> : null
                        }
                        {
                            this.state.punchOutPhoto ? <img src={this.state.punchOutPhoto} width="240px" className="img-rounded shift_image" /> : null
                        }
                    </div>
                </DialogInput>
            </Grid>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        employeeShift: state.entity.employeeShift,
        model: selectEmployeeShiftModel(state.form, componentName),
        saveTimestamp: state.form[`${componentName}SaveTimestamp`],
        saveSuccess: state.form[`${componentName}SaveSuccess`],
        saveError: state.form[`${componentName}SaveError`]
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getEmployeeTimesheet: (model) => dispatch(getEmployeeTimesheetByStatus(model)),
        formInput: (value, name) => dispatch(formInput(value, name)),
        clearForm: () => dispatch(clearEmployeeShiftForm(componentName)),
        clearEmployeeShift: () => dispatch(clearEmployeeShift()),
        save: (model) => dispatch(saveEmployeeShift(model, componentName)),
        showSnackbar: (message) => dispatch(showSnackbar(message)),
        showError: (message) => dispatch(showError(message))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(WithRouter(ShiftEdit));